"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var model_1 = require("../diagram/model");
var collections_1 = require("../viewUtils/collections");
var events_1 = require("../viewUtils/events");
var listElementView_1 = require("./listElementView");
var DirectionInImage = require('../../../images/direction-in.png');
var DirectionOutImage = require('../../../images/direction-out.png');
var CLASS_NAME = 'ontodia-instances-search';
var InstancesSearch = /** @class */ (function (_super) {
    tslib_1.__extends(InstancesSearch, _super);
    function InstancesSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.listener = new events_1.EventObserver();
        _this.onSelectedChanged = function (selected, model) {
            _this.setState(function (state) {
                var selectedItems = tslib_1.__assign({}, state.selectedItems);
                var previouslySelected = Boolean(selectedItems[model.id]);
                if (previouslySelected && !selected) {
                    delete selectedItems[model.id];
                }
                else if (!previouslySelected && selected) {
                    selectedItems[model.id] = true;
                }
                return { selectedItems: selectedItems };
            });
        };
        _this.state = {
            selectedItems: {},
            resultId: 0,
        };
        return _this;
    }
    InstancesSearch.prototype.render = function () {
        var _this = this;
        var ENTER_KEY_CODE = 13;
        var className = CLASS_NAME + " stateBasedProgress " + (this.props.className || '');
        var progressState = this.state.quering ? 'querying' :
            this.state.error ? 'error' :
                this.state.items ? 'finished' : undefined;
        var searchTerm = this.state.inputText === undefined
            ? this.props.criteria.text : this.state.inputText;
        return React.createElement("div", { className: className, "data-state": progressState },
            React.createElement("div", { className: 'ontodia-progress' },
                React.createElement("div", { className: 'ontodia-progress-bar ontodia-progress-bar-striped active', role: 'progressbar', "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": 100, style: { width: '100%' } })),
            React.createElement("div", { className: CLASS_NAME + "__criteria" },
                this.renderCriteria(),
                React.createElement("div", { className: CLASS_NAME + "__text-criteria ontodia-input-group" },
                    React.createElement("input", { type: 'text', className: 'ontodia-form-control', placeholder: 'Search for...', value: searchTerm || '', onChange: function (e) { return _this.setState({ inputText: e.currentTarget.value }); }, onKeyUp: function (e) {
                            if (e.keyCode === ENTER_KEY_CODE) {
                                _this.submitCriteriaUpdate();
                            }
                        } }),
                    React.createElement("span", { className: 'ontodia-input-group-btn' },
                        React.createElement("button", { className: 'ontodia-btn ontodia-btn-default', type: 'button', title: 'Search', onClick: function () { return _this.submitCriteriaUpdate(); } },
                            React.createElement("span", { className: 'fa fa-search', "aria-hidden": 'true' }))))),
            React.createElement("div", { className: CLASS_NAME + "__rest", key: this.state.resultId },
                this.renderSearchResults(),
                React.createElement("div", { className: CLASS_NAME + "__rest-end" },
                    React.createElement("button", { type: 'button', className: CLASS_NAME + "__load-more btn btn-primary", disabled: this.state.quering, style: { display: this.state.moreItemsAvailable ? undefined : 'none' }, onClick: function () { return _this.queryItems(true); } },
                        React.createElement("span", { className: 'fa fa-chevron-down', "aria-hidden": 'true' }),
                        "\u00A0Show more"))));
    };
    InstancesSearch.prototype.renderCriteria = function () {
        var _this = this;
        var _a = this.props, _b = _a.criteria, criteria = _b === void 0 ? {} : _b, view = _a.view;
        var criterions = [];
        if (criteria.elementType) {
            var classInfo = criteria.elementType;
            var classLabel = model_1.formatLocalizedLabel(classInfo.id, classInfo.label, view.getLanguage());
            criterions.push(React.createElement("div", { key: 'hasType', className: CLASS_NAME + "__criterion" },
                this.renderRemoveCriterionButtons(function () { return _this.props.onCriteriaChanged(tslib_1.__assign({}, _this.props.criteria, { elementType: undefined })); }),
                "Has type ",
                React.createElement("span", { className: CLASS_NAME + "__criterion-class", title: classInfo.id }, classLabel)));
        }
        else if (criteria.refElement) {
            var element = criteria.refElement;
            var elementLabel = model_1.formatLocalizedLabel(element.iri, element.data.label.values, view.getLanguage());
            var linkType = criteria.refElementLink;
            var linkTypeLabel = linkType
                ? model_1.formatLocalizedLabel(linkType.id, linkType.label, view.getLanguage()) : undefined;
            criterions.push(React.createElement("div", { key: 'hasLinkedElement', className: CLASS_NAME + "__criterion" },
                this.renderRemoveCriterionButtons(function () { return _this.props.onCriteriaChanged(tslib_1.__assign({}, _this.props.criteria, { refElement: undefined, refElementLink: undefined })); }),
                "Connected to ",
                React.createElement("span", { className: CLASS_NAME + "__criterion-element", title: element ? element.iri : undefined }, elementLabel),
                linkType && React.createElement("span", null,
                    ' through ',
                    React.createElement("span", { className: CLASS_NAME + "__criterion-link-type", title: linkType && linkType.id }, linkTypeLabel),
                    criteria.linkDirection === 'in' && React.createElement("span", null,
                        ' as ',
                        React.createElement("img", { className: CLASS_NAME + "__link-direction", src: DirectionInImage }),
                        "\u00A0source"),
                    criteria.linkDirection === 'out' && React.createElement("span", null,
                        ' as ',
                        React.createElement("img", { className: CLASS_NAME + "__link-direction", src: DirectionOutImage }),
                        "\u00A0target"))));
        }
        return React.createElement("div", { className: CLASS_NAME + "__criterions" }, criterions);
    };
    InstancesSearch.prototype.renderRemoveCriterionButtons = function (onClick) {
        return React.createElement("div", { className: CLASS_NAME + "__criterion-remove ontoidia-btn-group ontodia-btn-group-xs" },
            React.createElement("button", { type: 'button', className: 'ontodia-btn ontodia-btn-default', title: 'Remove criteria', onClick: onClick },
                React.createElement("span", { className: 'fa fa-times', "aria-hidden": 'true' })));
    };
    InstancesSearch.prototype.renderSearchResults = function () {
        var _this = this;
        var items = this.state.items || [];
        return React.createElement("ul", { className: CLASS_NAME + "__results" }, items.map(function (model) { return _this.renderResultItem(model); }));
    };
    InstancesSearch.prototype.renderResultItem = function (model) {
        var _this = this;
        var alreadyOnDiagram = this.props.view.model.elements.findIndex(function (element) { return element.iri === model.id && element.group === undefined; }) >= 0;
        return (React.createElement(listElementView_1.ListElementView, { key: model.id, model: model, view: this.props.view, disabled: alreadyOnDiagram, selected: this.state.selectedItems[model.id] || false, onSelectedChanged: alreadyOnDiagram ? undefined : this.onSelectedChanged, onDragStart: function (e) {
                var iris = Object.keys(tslib_1.__assign({}, _this.state.selectedItems, (_a = {}, _a[model.id] = true, _a)));
                return listElementView_1.startDragElements(e, iris);
                var _a;
            } }));
    };
    InstancesSearch.prototype.submitCriteriaUpdate = function () {
        var text = this.state.inputText === undefined ? this.props.criteria.text : this.state.inputText;
        text = text === '' ? undefined : text;
        this.props.onCriteriaChanged(tslib_1.__assign({}, this.props.criteria, { text: text }));
    };
    InstancesSearch.prototype.componentDidMount = function () {
        var _this = this;
        this.listener.listen(this.props.view.events, 'changeLanguage', function () { return _this.forceUpdate(); });
        this.listener.listen(this.props.view.model.events, 'changeCells', function () {
            var _a = _this.state, currentSelection = _a.selectedItems, items = _a.items;
            if (collections_1.isEmptyMap(currentSelection)) {
                if (items && items.length > 0) {
                    // redraw "already on diagram" state
                    _this.forceUpdate();
                }
            }
            else {
                var selectedItems = tslib_1.__assign({}, currentSelection);
                for (var _i = 0, _b = _this.props.view.model.elements; _i < _b.length; _i++) {
                    var element = _b[_i];
                    if (element.group === undefined && selectedItems[element.iri]) {
                        delete selectedItems[element.iri];
                    }
                }
                _this.setState({ selectedItems: selectedItems });
            }
        });
        this.queryItems(false);
    };
    InstancesSearch.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var languageChanged = this.currentRequest
            ? this.currentRequest.languageCode !== nextProps.view.getLanguage() : false;
        if (this.props.criteria !== nextProps.criteria || languageChanged) {
            this.setState({ inputText: undefined }, function () { return _this.queryItems(false); });
        }
    };
    InstancesSearch.prototype.componentWillUnmount = function () {
        this.listener.stopListening();
        this.currentRequest = undefined;
    };
    InstancesSearch.prototype.queryItems = function (loadMoreItems) {
        var _this = this;
        var request;
        if (loadMoreItems) {
            if (!this.currentRequest) {
                throw new Error('Cannot request more items without initial request.');
            }
            var _a = this.currentRequest, offset = _a.offset, limit = _a.limit;
            request = tslib_1.__assign({}, this.currentRequest, { offset: offset + limit });
        }
        else {
            request = createRequest(this.props.criteria, this.props.view.getLanguage());
        }
        if (!(request.text || request.elementTypeId || request.refElementId || request.refElementLinkId)) {
            this.setState({
                quering: false,
                error: undefined,
                items: undefined,
                moreItemsAvailable: false,
                selectedItems: {},
            });
            return;
        }
        this.currentRequest = request;
        this.setState({
            quering: true,
            error: undefined,
            moreItemsAvailable: false,
        });
        this.props.model.dataProvider.filter(request).then(function (elements) {
            if (_this.currentRequest !== request) {
                return;
            }
            _this.processFilterData(elements);
        }).catch(function (error) {
            if (_this.currentRequest !== request) {
                return;
            }
            console.error(error);
            _this.setState({ quering: false, error: error });
        });
    };
    InstancesSearch.prototype.processFilterData = function (elements) {
        var requestedAdditionalItems = this.currentRequest.offset > 0;
        var existingIris = {};
        if (requestedAdditionalItems) {
            this.state.items.forEach(function (item) { return existingIris[item.id] = true; });
        }
        var items = requestedAdditionalItems ? this.state.items.slice() : [];
        for (var iri in elements) {
            if (!elements.hasOwnProperty(iri)) {
                continue;
            }
            if (existingIris[iri]) {
                continue;
            }
            items.push(elements[iri]);
        }
        var moreItemsAvailable = Object.keys(elements).length >= this.currentRequest.limit;
        if (requestedAdditionalItems) {
            this.setState({ quering: false, items: items, error: undefined, moreItemsAvailable: moreItemsAvailable });
        }
        else {
            this.setState({
                quering: false,
                resultId: this.state.resultId + 1,
                items: items,
                error: undefined,
                moreItemsAvailable: moreItemsAvailable,
                selectedItems: {},
            });
        }
    };
    return InstancesSearch;
}(React.Component));
exports.InstancesSearch = InstancesSearch;
function createRequest(criteria, language) {
    var text = criteria.text, elementType = criteria.elementType, refElement = criteria.refElement, refElementLink = criteria.refElementLink, linkDirection = criteria.linkDirection;
    return {
        text: text,
        elementTypeId: elementType ? elementType.id : undefined,
        refElementId: refElement ? refElement.iri : undefined,
        refElementLinkId: refElementLink ? refElementLink.id : undefined,
        linkDirection: linkDirection,
        offset: 0,
        limit: 100,
        languageCode: language || 'en',
    };
}
